import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import Contactpage from '../../components/Contactpage'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import { Helmet } from 'react-helmet';
import contactBanner from '../../images/banners/contact.webp'


const ContactPage =() => {
    return(
        <Fragment>
            <Helmet>
                <title>Contact | Dar-ul-Quran Academy UK</title>
                <meta name="description" content="Contact Dar-ul-Quran Academy for inquiries, enrollment, or support. We're here to help UK families on their Quran-learning journey." />
                <link rel="canonical" href="https://www.thedarulquran.com/contact" />
            </Helmet>
            <Navbar/>
            <PageTitle pageTitle={'Contact Us'} pagesub={'Contact'} backgroundImage={contactBanner} hideText={true}/> 
            <Contactpage/>
            <Footer footerClass={'wpo-ne-footer-2'}/>
            <Scrollbar/>
        </Fragment>
    )
};
export default ContactPage;

